"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stimulus = void 0;
/**
 * It represents the Stimulus object in Learnosity
 * @property {string} title     - stimulus title
 * @property {string} author    - stimulus author
 * @property {string} textType  - stimulus text type
 */
var Stimulus = /** @class */ (function () {
    function Stimulus(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return Stimulus;
}());
exports.Stimulus = Stimulus;
